export default {
  IN_UTERO_UNKNOWN_MOMENT: 'in_utero_unknown_moment',
  IN_UTERO_KNOWN_MOMENT: 'in_utero_known_moment',
  DEATH_IN_LABOR_OR_CHILDBIRTH: 'death_in_labor_or_childbirth',
};
